import { Component, Input } from '@angular/core';

@Component({
	selector: 'calendar-footer',
	templateUrl: './calendar-footer.component.html',
	styleUrls: ['./calendar-footer.component.scss'],
})
export class CalendarFooterComponent {
	@Input() currentTimezone: string;
}
